import { useCallback, useEffect, useState } from "react";

const FAVORITES_KEY = "jp-ethics-favorites";

function readFavorites(): string[] {
  try {
    const raw = window.localStorage.getItem(FAVORITES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === "string") : [];
  } catch {
    return [];
  }
}

function writeFavorites(list: string[]) {
  try {
    window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(list));
  } catch {
    // storage may be unavailable in private mode; demo keeps working in memory
  }
}

export function useFavorite(movieId: string) {
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    setIsFavorite(readFavorites().includes(movieId));
  }, [movieId]);

  const toggle = useCallback(() => {
    const list = readFavorites();
    const next = list.includes(movieId)
      ? list.filter((id) => id !== movieId)
      : [...list, movieId];
    writeFavorites(next);
    setIsFavorite(next.includes(movieId));
    return next.includes(movieId);
  }, [movieId]);

  return { isFavorite, toggle };
}

export function useFavoriteCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(readFavorites().length);
  }, []);

  return count;
}